import { fetchRequest } from "@common/helpers/util/requestMiddleware";

import { casinoMiddlewareToken, casinoMiddlewareURL } from "./constants";
import CasinoMiddlewareAuth from "./auth";

const unauthorizedStatuses = new Set([401, 403]);

const checkAuthorization = (makeRequest) => (
  async (...args) => {
    try {
      if (!CasinoMiddlewareAuth.isAuthorized) {
        await CasinoMiddlewareAuth.authorize();
      }

      return await makeRequest(...args);
    } catch (e) {
      if (unauthorizedStatuses.has(e.response?.status)) {
        CasinoMiddlewareAuth.onUnauthorize();
        return null;
      }

      throw e;
    }
  }
);

export const getCasinoTicketStates = checkAuthorization((body) => (
  fetchRequest(
    casinoMiddlewareURL,
    'api/tickets/getTicketsStates',
    'POST',
    {
      headers: { Authorization: `Bearer ${CasinoMiddlewareAuth.authData.JwtToken}` },
      body,
    },
  )
));

export const getCasinoTickets = (body) => (
  fetchRequest(
    casinoMiddlewareURL,
    `api/tickets/GetTicketInfoByTransactionIdsTokenAuth?token=${casinoMiddlewareToken}`,
    'POST',
    { body },
  )
);

export const getCasinoTicketsByCashdeskId = checkAuthorization((cashdeskId) => (
  fetchRequest(
    casinoMiddlewareURL,
    `api/tickets/GetTicketsByCashdeskId/${cashdeskId}`,
    'GET',
    {
      headers: { Authorization: `Bearer ${CasinoMiddlewareAuth.authData.JwtToken}` },
    },
  )
));

export const markCasinoTicketAsDelivered = checkAuthorization((body) => (
  fetchRequest(
    casinoMiddlewareURL,
    'api/tickets/MarkTicketAsDelivered',
    'POST',
    {
      headers: { Authorization: `Bearer ${CasinoMiddlewareAuth.authData.JwtToken}` },
      body,
    },
  )
));
